import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useTracking from './useTracking';

const PageTracker = () => {
  const { trackPageView } = useTracking();
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname, trackPageView]);

  return null;
};

export default PageTracker;
